import { Col, Row } from "react-bootstrap";
import { NFDateInput } from "../../../../Shared/NewForms/NFDateInput";
import { NFTextInput } from "../../../../Shared/NewForms/NFTextInput";
import { NFLookupCompany } from "../../../../Shared/NewForms/NFLookupCompany";
import { NFLookupInput } from "../../../../Shared/NewForms/NFLookupInput";
import { NFLookupCashflowItem } from "../../../../Shared/NewForms/NFLookupCashflowItem";
import { NFLookupBankAccount } from "../../../../Shared/NewForms/NFLookupBankAccount";
import { NFLookupDivision } from "../../../../Shared/NewForms/NFLookupDivision";
import { NFLookupPaymentRequests } from "../../../../Shared/NewForms/NFLookupPaymentRequests";
import { NFIntInput } from "../../../../Shared/NewForms/NFIntInput";
import { NFLookupCurrency } from "../../../../Shared/NewForms/NFlookupCurrency";
import { EnumHelper } from "../../../../../helpers/EnumHelper";
import { useTranslation } from "react-i18next";
import { NFLookupVendorCustomer } from "../../../../Shared/NewForms/NFLookupVendorCustomer";
import { NFLookupContract } from "../../../../Shared/NewForms/NFLookupContract";
import { NFLookupCashRegister } from "../../../../Shared/NewForms/NFLookupCashRegister";
import { useFormContext } from "react-hook-form";

const IncomingBanksCashDepositToBankDetail = () => {
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput fieldName="comment" title={t("Comment")} />
        </Col>
        <Col sm={6}>
          <NFLookupCashRegister title={t("SenderCashRegister")} fieldName="senderCashRegisterId" required />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupVendorCustomer fieldName="vendorCustomerId" title={t("VendorsAndCustomers")} required />
        </Col>
        <Col sm={6}>
          <NFLookupContract fieldName="contractId" title={t("Contract")} required />
        </Col>
      </Row>
    </>
  );
};

export default IncomingBanksCashDepositToBankDetail;
